/**
 *	Mapping wallet url's to moneynodeweb
 *	These url's will be redirected back to moneynodeweb for the user in PXP experiment
 */
const mappingUrls = {
	'/myaccount/wallet/balance': '/myaccount/money/balances/summary'
};

/**
 * Client side redirection for moneyflows
 * @param isFlow
 */
function checkForRedirection(isFlow) {
	if (isFlow) {
		let currentUrl = window.location.href.replace(/.*\/myaccount/, '/myaccount'),
			targetUrl = mappingUrls[currentUrl];

		if (targetUrl) {
			window.location.href = targetUrl;
			return;
		}
	}
}

export default {
	mappingUrls: mappingUrls,
	checkForRedirection: checkForRedirection
};



// WEBPACK FOOTER //
// ./routes/moneyflows/routesMapping.es6